import { tallyTokens } from "../../theme.tsx";
import React from "react";
import { Box, useTheme } from "@mui/material";
import TallyBrownLogo from "../../assets/tally-brown.png";

interface AvatarPanelProps {
  children?: React.ReactNode;
  /** Pulses while Tally is working on this answer. */
  working?: boolean;
}

const AvatarPanel: React.FC<AvatarPanelProps> = ({ working = false }) => {
  const theme = useTheme();
  const backgroundColor = theme.palette.primary.main;

  return (
    <Box
      justifyContent="center"
      alignItems="center"
      display="flex"
      sx={{
        // Keep the reply footprint fixed while giving the mark breathing room.
        backgroundColor: backgroundColor,
        height: { xs: "22px", md: "27px" },
        width: { xs: "22px", md: "27px" },
        borderRadius: "50%",
        flexShrink: 0,
        marginTop: "1px",
        overflow: "hidden", // Keep the image within the circle.
        // The working state that used to play on the large corner logo: a ring
        // of the brand colour breathing out from the mark.
        ...(working && {
          "@keyframes tally-avatar-pulse": {
            "0%": { boxShadow: "0 0 0 0 rgba(169, 125, 88, 0.45)" },
            "70%": { boxShadow: "0 0 0 7px rgba(169, 125, 88, 0)" },
            "100%": { boxShadow: "0 0 0 0 rgba(169, 125, 88, 0)" },
          },
          animation: "tally-avatar-pulse 1.6s ease-out infinite",
          "@media (prefers-reduced-motion: reduce)": {
            animation: "none",
            boxShadow: `0 0 0 3px ${tallyTokens.brandWash}`,
          },
        }),
      }}
      data-working={working || undefined}
    >
      <Box
        component="img"
        src={TallyBrownLogo}
        alt="Tally Assistant Avatar"
        sx={{
          width: "80%",
          height: "80%",
          borderRadius: "50%",
          objectFit: "contain", // Maintain aspect ratio
        }}
      />
    </Box>
  );
};

export default AvatarPanel;
